import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CLStaffGradeService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CLStaffGrades`);
    }
}